import * as serviceWorker from './serviceWorker';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';

import './index.css';

datadogRum.init({
  applicationId: 'f47db35d-e0cc-4325-a35a-aa93b5bdf682',
  clientToken: 'pubb483370d6bc929d4ab3ddb938eb6da74',
  site: 'datadoghq.com',
  service: 'portfolio',
  sessionSampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
